import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es6.regexp.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
import { mapMutations } from "vuex";
import Loading from 'quasar/src/plugins/Loading.js';import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';;
var loading = function loading(message) {
  if (!Loading.isActive) {
    return Loading.show({
      message: message,
      backgroundColor: "white",
      customClass: "loading-class",
      spinnerColor: "primary"
    });
  }
};
export default {
  name: "paineis",
  data: function data() {
    return {
      panels: [],
      requestService: new RequestService(),
      clienteId: 0,
      showArrowScroll: false,
      AppFullscreen: AppFullscreen,
      onFullScreen: false
    };
  },
  mounted: function mounted() {
    this.clienteId = this.$route.params.cliente;
    if (!this.requestService.revalidarToken(this.clienteId)) {
      this.$router.replace("/");
    } else {
      loading("<h5>Carregando paineis...</h5>");
      this.setTitle(" ");
      this.getPanels();
      this.initFocusEvent();
    }
  },
  updated: function updated() {
    this.checkScroll();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations("vuex_module", ["setTitle"])), {}, {
    getPanels: function getPanels() {
      var _this = this;
      this.requestService.getPanels(this.clienteId).then(function (_ref) {
        var data = _ref.data;
        _this.panels = data;
        Loading.hide();
      });
    },
    toggleFullScreen: function toggleFullScreen() {
      if (this.onFullScreen) {
        AppFullscreen.exit();
      } else {
        AppFullscreen.request();
      }
      this.onFullScreen = !this.onFullScreen;
    },
    checkScroll: function checkScroll() {
      var _this2 = this;
      var elementScroll = null;
      var checkState = setInterval(function () {
        elementScroll = document.querySelector(".created-painels");
        if (elementScroll) {
          clearInterval(checkState);
          if (elementScroll.scrollWidth > elementScroll.clientWidth) {
            _this2.showArrowScroll = true;
          }
        }
      });
    },
    initFocusEvent: function initFocusEvent() {
      document.querySelector("[tabindex='1']").focus();
    },
    goToPainelPage: function goToPainelPage(painel) {
      this.$router.push("/".concat(this.clienteId, "/painel/").concat(painel.panelChannel));
    },
    goToClientePage: function goToClientePage() {
      this.$router.push("/".concat(this.clienteId, "/config"));
    },
    scrollRight: function scrollRight() {
      var containerPainels = document.querySelector(".created-painels");
      containerPainels.scrollLeft += containerPainels.scrollWidth / 3;
    },
    scrollLeft: function scrollLeft() {
      var containerPainels = document.querySelector(".created-painels");
      containerPainels.scrollLeft -= containerPainels.scrollWidth / 3;
    }
  })
};